var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect2, _rect3, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 261,
    viewBox: "0 0 118 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 261,
    fill: "#12111C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 65H103V81H87V65Z",
    fill: "#61D9D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65H103V81H87V65Z",
    fill: "#61D9D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65H67V81H51V65Z",
    fill: "#61D9D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65H67V81H51V65Z",
    fill: "#61D9D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 65H31V81H15V65Z",
    fill: "#61D9D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 65H31V81H15V65Z",
    fill: "#61D9D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87 123H103V139H87V123Z",
    fill: "#61D9D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87 123H103V139H87V123Z",
    fill: "#61D9D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123H67V139H51V123Z",
    fill: "#61D9D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123H67V139H51V123Z",
    fill: "#61D9D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 123H31V139H15V123Z",
    fill: "#61D9D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15 123H31V139H15V123Z",
    fill: "#61D9D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94H103V110H87V94Z",
    fill: "#61D9D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94H103V110H87V94Z",
    fill: "#61D9D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51 94H67V110H51V94Z",
    fill: "#61D9D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51 94H67V110H51V94Z",
    fill: "#61D9D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15 94H31V110H15V94Z",
    fill: "#61D9D2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15 94H31V110H15V94Z",
    fill: "#61D9D2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87 152H103V168H87V152Z",
    fill: "#61D9D2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87 152H103V168H87V152Z",
    fill: "#61D9D2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M51 152H67V168H51V152Z",
    fill: "#61D9D2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51 152H67V168H51V152Z",
    fill: "#61D9D2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15 152H31V168H15V152Z",
    fill: "#61D9D2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15 152H31V168H15V152Z",
    fill: "#61D9D2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87 181H103V197H87V181Z",
    fill: "#61D9D2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87 181H103V197H87V181Z",
    fill: "#61D9D2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51 181H67V197H51V181Z",
    fill: "#61D9D2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51 181H67V197H51V181Z",
    fill: "#61D9D2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31 217H88V261H31V217Z",
    fill: "#F6F6F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 228,
    width: 17,
    height: 33,
    fill: "#61D9D2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 228,
    width: 17,
    height: 33,
    fill: "#61D9D2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15 181H31V197H15V181Z",
    fill: "#61D9D2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15 181H31V197H15V181Z",
    fill: "#61D9D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding3);
export default __webpack_public_path__ + "static/media/Building3.7773b85a87fb96636fe86f9d425a9b61.svg";
export { ForwardRef as ReactComponent };